"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStringValueToSqlPrimitive = exports.convertStrictNonEmptyString = exports.convertOptionalDateTimeStamp = exports.convertStrictPercentageToFraction = exports.convertOptionalCurrencyFactory = exports.convertStrictCurrencyFactory = exports.convertStringBoolean = exports.convertStrictInteger = exports.convertOptionalNumber = exports.convertStrictNumber = exports.currencyStrToNumber = exports.isEmptyString = void 0;
const accounting_1 = __importDefault(require("accounting"));
const _ = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const error_1 = require("../error");
const typeguards_1 = require("../typeguards");
const isEmptyString = (val) => !/\S/.test(val);
exports.isEmptyString = isEmptyString;
// Using new accounting lib, since currency-formatter is limited and in maintenance mode
const currencyStrToNumber = (val, code) => {
    const currencyCodeRegExpMap = {
        [finley_types_1.Bank.Currency
            .USD]: /^\s*-? *\$?\s*(\d{1,3}(,\d{3})*|(\d+))(\.\d{1,})?\s*$/,
        [finley_types_1.Bank.Currency
            .MXN]: /^\s*-? *(?:MX)?\s*\$?\s*(\d{1,3}(,\d{3})*|(\d+))(\.\d{1,})?\s*$/,
        [finley_types_1.Bank.Currency
            .EUR]: /^\s*-? *(?:EUR|€)?\s*(\d{1,3}(,\d{3})*|(\d+))(\.\d{1,})?\s*(?:EUR)?\s*$/,
        [finley_types_1.Bank.Currency
            .GBP]: /^\s*-? *(?:£)?\s*(\d{1,3}(,\d{3})*|(\d+))(\.\d{1,})?\s*$/,
    };
    const currencyCodeRegexp = currencyCodeRegExpMap[code];
    if (!currencyCodeRegexp) {
        return null;
    }
    // if a value has matching parens, replace with a negative value
    const parenMatch = String(val).match(/^\s*\$?\s*\((.*)\)\s*$/);
    if (parenMatch) {
        // eslint-disable-next-line no-param-reassign
        val = `-${parenMatch[1]}`;
    }
    // '$ -' is a format that we can get, which means 0 in some financial formats
    const zeroValueMatch = String(val).match(/(^[^0-9]*)-\s*$/);
    if (zeroValueMatch) {
        // eslint-disable-next-line no-param-reassign
        val = `${zeroValueMatch[1]}0`;
    }
    if (!currencyCodeRegexp.exec(val)) {
        return null;
    }
    return accounting_1.default.unformat(val);
};
exports.currencyStrToNumber = currencyStrToNumber;
// acceptable non-numeric values to remove
const removeableNumberChars = /\s|%|,/g;
const cleanInitialValue = (val) => {
    return String(val).replace(removeableNumberChars, '');
};
const isNilOrEmpty = (val) => {
    return _.isNil(val) || val === '';
};
const convertStrictNumber = (val, key) => {
    // To note, this will also help manage scientific notation values,
    // as "Number(val)" helps manage this conversion
    const number = Number(cleanInitialValue(val));
    if (_.isNaN(number)) {
        let errMsg = `Expected a number in converting \`${val}\` in convertStrictNumber`;
        if (key) {
            errMsg = `${errMsg} for key \`${key}\``;
        }
        throw Error(errMsg);
    }
    return number;
};
exports.convertStrictNumber = convertStrictNumber;
const convertOptionalNumber = (val, key) => {
    if (isNilOrEmpty(val)) {
        return null;
    }
    const number = (0, exports.convertStrictNumber)(val, key);
    return number;
};
exports.convertOptionalNumber = convertOptionalNumber;
const convertStrictInteger = (val, key) => {
    const integer = Number(cleanInitialValue(val));
    // isInteger does a null check
    if (!Number.isInteger(integer)) {
        let errMsg = `Expected a integer in converting \`${val}\` in convertStrictInteger`;
        if (key) {
            errMsg = `${errMsg} for key \`${key}\``;
        }
        throw Error(errMsg);
    }
    return integer;
};
exports.convertStrictInteger = convertStrictInteger;
/**
 * Convert e.g. "TRUE" to a boolean `true`
 * @param booleanString "TRUE"
 * @returns boolean, e.g. `true`
 */
const convertStringBoolean = (value, trueString) => {
    const caseInsensitiveTrueString = trueString && _.toUpper(trueString);
    return _.toUpper(value || '') === (caseInsensitiveTrueString || 'TRUE');
};
exports.convertStringBoolean = convertStringBoolean;
const convertStrictCurrencyFactory = (currencyCode) => (val) => {
    const currencyVal = (0, exports.currencyStrToNumber)(val, currencyCode);
    (0, error_1.finleyAssert)(_.isFinite(currencyVal), new error_1.FinleyError(`Expected convertStrictCurrencyFactory to convert ${val}`));
    return currencyVal;
};
exports.convertStrictCurrencyFactory = convertStrictCurrencyFactory;
const nullOrCurrencyStrToNumber = (val, code) => {
    if (isNilOrEmpty(val)) {
        return null;
    }
    return (0, exports.currencyStrToNumber)(val, code);
};
const convertOptionalCurrencyFactory = (currencyCode) => (val) => nullOrCurrencyStrToNumber(val, currencyCode);
exports.convertOptionalCurrencyFactory = convertOptionalCurrencyFactory;
/**
 * Convert percent to float by dividing by 100
 * use convertStrictNumber is you do not want to divide val by 100
 * @returns float e.g. val / 100
 */
const convertStrictPercentageToFraction = (val) => {
    const percentage = Number(cleanInitialValue(val));
    (0, error_1.finleyAssert)(!_.isNaN(percentage), new error_1.FinleyError(`Expected a percentage in converting \`${val}\` in convertStrictPercentageToFraction`));
    return percentage / 100.0;
};
exports.convertStrictPercentageToFraction = convertStrictPercentageToFraction;
const convertStrictDateTimeStamp = (dateTimeStamp) => {
    // this confirms that the timestamp has at least HH:MM:SS
    const timeStampRegex = /\d*:\d*:\d*/;
    (0, error_1.finleyAssert)(timeStampRegex.exec(dateTimeStamp), new error_1.FinleyError('Expected this value to be a timestamp'));
    return new Date(dateTimeStamp);
};
const convertOptionalDateTimeStamp = (dateTimeStamp) => {
    if (!dateTimeStamp) {
        return null;
    }
    return convertStrictDateTimeStamp(dateTimeStamp);
};
exports.convertOptionalDateTimeStamp = convertOptionalDateTimeStamp;
const convertStrictNonEmptyString = (val, key) => {
    if (!_.isString(val) || val.length === 0) {
        let errMsg = `Expected a string in converting \`${val}\` in convertStrictNonEmptyString`;
        if (key) {
            errMsg = `${errMsg} for key \`${key}\``;
        }
        throw Error(errMsg);
    }
    return val;
};
exports.convertStrictNonEmptyString = convertStrictNonEmptyString;
const parseStringValueToSqlPrimitive = (params) => {
    const { value, parseString } = params;
    // If don't need to parse or already non-string, just return value
    if (!parseString || typeof value !== 'string') {
        return value;
    }
    if ((0, typeguards_1.isFullDateStr)(value)) {
        return value;
    }
    if (value.match(/^[-+]?[0-9]*\.[0-9]*$/) && _.isFinite(parseFloat(value))) {
        return parseFloat(value);
    }
    if (value.match(/^[-+]?[0-9]+$/) && _.isFinite(parseInt(value, 10))) {
        return parseInt(value, 10);
    }
    if (value.toUpperCase() === 'TRUE') {
        return true;
    }
    if (value.toUpperCase() === 'FALSE') {
        return false;
    }
    return value;
};
exports.parseStringValueToSqlPrimitive = parseStringValueToSqlPrimitive;
//# sourceMappingURL=index.js.map